<mat-card *ngIf="page_flag">
    <!-- <div class="row">
        <div class="col-12">
            <p class="noc_t">NOC List</p>
        </div>
    </div> -->
    <mat-tab-group mat-stretch-tabs="false" class="over">

        <mat-tab label="In Process NOC files"> <br>
            <div *ngIf="list_flag">
                <div class="row">
                    <div class="col-11">
                        <div class="filter d-flex">
                            <i class="fa fa-search search_icon" aria-hidden="true"></i>
                            <input class="input-filter" placeholder="Search by Name, Letter and Number"
                                (keyup)="applyFilter($any($event.target).value)">
                        </div>
                    </div>
                    <div class="col-1 text-center">
                        <div class="export_btn mt-1">
                            <button class="btn_export" (click)="export()" >Export</button>
                        </div>
                    </div>
                </div>
                <div class="example-container mt-2" style="text-size-adjust: 2;">
                    <table mat-table [dataSource]="datasource" matSort>
                        <ng-container matColumnDef="si_no">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>SI.NO</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.new_index}}</td>
                        </ng-container>
                        <ng-container matColumnDef="applicant_name">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Applicant Name</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.party_name}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="file_number">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>File Number</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.file_number}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="letter_number">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Letter Number</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.lda_letter_number}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Date">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Date</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.arr_effective_date | date: 'dd MMMM, yyyy'}}   </td>
                        </ng-container>
                        <ng-container matColumnDef="trans_id">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Transaction ID</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.txn_id}}</td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Status</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.life_cycle_status}}</td>
                        </ng-container>
                        <ng-container matColumnDef="bill_amount">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Bill Amount</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.registration_amount}}</td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Action</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">

                                <button class="btn btn-outline-primary" *ngIf="element.bill_status != 'VERIFYED'"
                                    (click)="send_to_ctp(element)">Notify CTP</button>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator #paginator0 [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
                </div>
            </div>




            <div *ngIf="create_flag">
                <mat-horizontal-stepper [linear]="isLinear" #stepper1>
                    <mat-step [stepControl]="first" label="File Creation" completed="false">
                        <div class="row">
                            <div class="col-12">
                                <div class="div_header mt-3">
                                    <h6 class="text_sty">File Details</h6>
                                    <hr>
                                    <div class="inner_div mt-1">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>Applicant Name :</p>
                                            </div>
                                            <div class="col-md-6 text-right">{{Obj['party_name']}}</div>
                                        </div>
                                        <div class="row ">
                                            <div class="col-md-6">
                                                <p>Applicant Mobile Number :</p>
                                            </div>
                                            <div class="col-md-6 text-right">{{Obj['party_mobile']}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>LDA Letter Number :</p>
                                            </div>
                                            <div class="col-md-6 text-right">{{Obj['lda_letter_number']}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>Building Type :</p>
                                            </div>
                                            <div class="col-6 text-right">{{Obj['building_type']}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>File Number :</p>
                                            </div>
                                            <div class="col-md-6 text-right">{{Obj['file_number']}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <br>

                        <div class="row">
                            <div class="col-12">
                                <div class="div_header mt-3">
                                    <h6 class="text_sty">Transaction Details</h6>
                                    <hr>
                                    <div class="inner_div mt-1">
                                        <div class="row">
                                            <div class="col-md-3">
                                                <p>Transaction ID :</p>
                                            </div>
                                            <div class="col-md-3">
                                                <p>Payment Mode :</p>
                                            </div>
                                            <div class="col-md-3">
                                                <p>Transaction Date :</p>
                                            </div>
                                            <div class="col-md-3">
                                                <p>Transaction Time :</p>
                                            </div>
                                            <!-- <div class="col-md-6 text-right">{{Obj['party_name']}}</div> -->
                                        </div>
                                        <div class="row ">
                                            <!-- <div class="col-md-6">
                                                <p>Applicant Mobile Number :</p>
                                            </div> -->
                                            <div class="col-md-3 ">{{Obj['txn_id']}}</div>
                                            <div class="col-md-3 ">{{Obj['payment_option']}}</div>
                                            <div class="col-md-3 ">{{Obj['arr_effective_date'] | date: 'dd-MM-yyyy'}}
                                            </div>
                                            <div class="col-md-3 ">{{Obj['valid_from_txn'] | date: 'hh:mm a'}}</div>

                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>


                    </mat-step>










                </mat-horizontal-stepper>
            </div>
        </mat-tab>


        <mat-tab label="Approved Bills">
            <div *ngIf="list_flag">
                <div class="row">
                    <div class="col-11">
                        <div class="filter d-flex">
                            <i class="fa fa-search search_icon" aria-hidden="true"></i>
                            <input class="input-filter" placeholder="Search by Name, Letter and Number"
                                (keyup)="applyFilter($any($event.target).value)">
                        </div>
                    </div>
                    <div class="col-1 text-center">
                        <div class="export_btn mt-1">
                            <button class="btn_export" (click)="export_verifyed()">Export</button>
                        </div>
                    </div>
                </div>
                <div class="example-container mt-2" style="text-size-adjust: 2;">
                    <table mat-table [dataSource]="datasource_verfyed" matSort>
                        <ng-container matColumnDef="si_no">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>SI.NO</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.new_index}}</td>
                        </ng-container>
                        <ng-container matColumnDef="applicant_name">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Applicant Name</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.party_name}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="file_number">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>File Number</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.file_number}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="letter_number">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>LDA Letter Number</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.lda_letter_number}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Date">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Date</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.arr_effective_date}}</td>
                        </ng-container>
                        <ng-container matColumnDef="trans_id">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>trans_id</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.txn_id}}</td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Status</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.life_cycle_status}}</td>
                        </ng-container>
                        <ng-container matColumnDef="bill_amount">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Bill Amount</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.registration_amount}}</td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Action</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">

                                <!-- <button class="btn btn-outline-primary" *ngIf="element.bill_status != 'VERIFYED'"
                                (click)="send_to_ctp(element)">Notify CTP</button> -->
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
                </div>
            </div>
        </mat-tab>

    </mat-tab-group>
</mat-card>

<div *ngIf="create_flag">
    <mat-card>

        <div class="row">
            <div class="col-12 text-right">
                <button class="bck" (click)="back()">Back</button> &nbsp;&nbsp;
                <!--Back-->
                <button class="AMC" (click)="submit()">Confirm and Notify CTP</button>

            </div>
        </div>

    </mat-card>
</div>


<!-- WORKFLOW MODEL -->
<div class="modal" id="myModal3">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Approval</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row"
                    *ngIf="ApprovalUserService.vendorflag==false && ApprovalUserService.approvalflag==false">
                    <div class="col-4 text-right">
                        <h6>Select Forwarded To :</h6>
                    </div>
                    <div class="col-4">
                        <ng-select [items]="ApprovalUserService.workuser" bindLabel="desc" bindValue="user_id_appr"
                            [multiple]="false" placeholder="Select User" [(ngModel)]="forwarded_user_id"
                            [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="true"
                            name="work_order_id">
                        </ng-select>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-4 text-right">
                        <h6>Remark :</h6>
                    </div>
                    <div class="col-4">
                        <textarea style="width: 100%; height: 80px;" id="re" name="re" [(ngModel)]="appr_remark"
                            placeholder="Enter Your Remark" class="form-control"></textarea>
                    </div>
                </div>
                <br>

                <div>
                    <table class="table table-bordered"
                        style="width: 90%; margin-left: 5%;overflow-x:scroll;scroll-margin-block: 1; ">
                        <thead>
                            <tr style="background-color:  white;">
                                <th style="width: 20%;">S No.</th>
                                <th style="width: 20%;">Decription</th>
                                <th style="width: 60%;">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let ln of undertakings;let i = index">
                                <td>{{i+1}}</td>
                                <td>{{ln['desc']}}</td>
                                <td style="width: 60%;">
                                    <input type="checkbox" [(ngModel)]="ln['check']" style="color: green;">

                                </td>
                            </tr>

                        </tbody>

                    </table>
                </div>
                <br>
                <div class="row" style="border: black;">
                    <div class="col-4 text-right">
                        <input type="checkbox" [(ngModel)]="message_flag" id="vehicle1" name="vehicle1" value="Bike">
                    </div>
                    <div class="col-4">
                        Notify Them
                    </div>
                </div>
                <br>
                <div class="row"
                    *ngIf="ApprovalUserService.vendorflag==false && ApprovalUserService.approvalflag==false">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" data-dismiss="modal" (click)="Approvedapproval()">Submit
                        </button>
                    </div>
                </div>
                <div class="row"
                    *ngIf="ApprovalUserService.vendorflag==false && ApprovalUserService.approvalflag==true">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" data-dismiss="modal" (click)="lastlevelappr()">Submit
                        </button>
                    </div>
                </div>
                <br>

                <div *ngIf="ApprovalUserService.vendorflag==true" class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" data-dismiss="modal" (click)="Approvedapproval()">Forward To
                            Vendor</button>
                    </div>
                </div>
                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>
</div>